<template>
  <v-dialog v-model="showWarning" persistent width="30%">
    <div class="logout-warning px-4 py-5" data-e2e-id="session-timeout-dialog">
      <h1>Need More Time?</h1>
      <p class="headline">
        Your session is about to expire. You will be automatically signed out in
        <strong>{{ timeRemainingSeconds }} seconds</strong>.
      </p>
      <div class="text-right">
        <app-button-cancel data-e2e-id="session-timeout-logout" class="mr-3" @click="logout">
          Sign Out
        </app-button-cancel>
        <app-button data-e2e-id="session-timeout-dismiss" @click="dismiss">
          Continue
        </app-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { keycloakService } from '@/services/keycloak-service'
import moment from 'moment'
import idleTimeout from 'idle-timeout'
import { sessionTimeoutSeconds, sessionTimeoutWarningSeconds } from '@/config/timeout-config'

export default {
  data: () => ({
    showWarning: false,
    activityMonitor: null,
    timeRemainingSeconds: 1,
    logoutTimeout: null,
    logoutTime: null,
    countdownInterval: null
  }),
  computed: {
    activityTimeoutMillis() {
      return sessionTimeoutSeconds * 1000
    },
    warningTimeoutMillis() {
      return sessionTimeoutWarningSeconds * 1000
    }
  },
  created() {
    this.activityMonitor = idleTimeout(this.handleActivityTimeout, {
      element: document,
      timeout: this.activityTimeoutMillis,
      loop: false
    })
  },
  methods: {
    handleActivityTimeout() {
      this.startLogoutTimeout()
      this.showWarning = true
    },
    updateCountdown() {
      this.timeRemainingSeconds = this.logoutTime.diff(moment(), 'seconds')
    },
    dismiss() {
      clearTimeout(this.logoutTimeout)
      clearInterval(this.countdownInterval)
      this.activityMonitor.reset()
      this.showWarning = false
    },
    logout() {
      keycloakService.logout()
    },
    startLogoutTimeout() {
      this.logoutTime = moment().add(this.warningTimeoutMillis, 'milliseconds')
      this.updateCountdown()
      this.countdownInterval = setInterval(this.updateCountdown, 750)
      this.logoutTimeout = setTimeout(this.logout, this.warningTimeoutMillis)
    }
  }
}
</script>

<style lang="scss" scoped>
.logout-warning {
  background-color: var(--v-white-base);
}
</style>
